import { UntypedFormGroup } from '@angular/forms';
import { TableColumn } from '@swimlane/ngx-datatable';

/**
 * Shared components models
 */
export interface Input {
  type: string;
  label: string;
  placeholder: string;
  control: string;
}

export interface FormFields {
  form: UntypedFormGroup;
  rows: Array<FormFieldRow>;
}

/**
 * Input types
 */
export enum InputTypes {
  INPUT = 'INPUT',
  TEXTAREA = 'TEXTAREA',
  SELECT = 'SELECT',
}

/**
 * FormField row
 */
export interface FormFieldRow {
  class: string;
  fields: Array<GeneralFields>;
}

/**
 * Form Input
 */
export interface FormInput {
  type?: string;
}

/**
 * Form Select
 */
export interface FormSelect extends FormInput {
  option?: Array<any>;
  valueKey?: string;
  displayKey?: string;
}

/**
 * Form Textarea
 */
export interface GeneralFields extends FormSelect {
  inputType?: InputTypes;
  error?: string;
  controlName?: string;
  label?: string;
  class?: string;
}

/**
 * Drag upload
 */
export interface DragUpload {
  valid: boolean;
  invalid: boolean;
  value: Array<DragUploadValue>;
}

export interface DragUploadValue {
  name: string;
  value: any;
}

export interface DatatableColumn extends TableColumn {
  name: string;
  prop: string;
  fieldName: string;
  fieldType?: string;
  dropdownValues?: any;
  allowDecrypt?: boolean;
  selectedValue?: any;
  fieldKey?: string;
  filterCondition?: any;
  filterValue?: any;
  filterValue2?: any;
  isFilterApplied?: boolean;
  minValue?: any;
  maxValue?: any;
  isRelation?: boolean;
  isLookup?: boolean;
  lookupTargetFieldId?: number | null;
  proxyFieldKey?: string | null;
  proxyFieldType?: string | null;
  proxyDecryptionAllowed?: boolean;
  IsSummaryField?: number;
  IsUrlField?: number;
  isHyperLink?: number | string | boolean;
  isUrl?: number | string | boolean;
  isFile?: number | string | boolean;
  isHtmlallowed?: number | string | boolean;
  isEmail?: number | string | boolean;
  valueAlign?: string;
  isEditAllowed?:boolean;
  IsNullable?:boolean;
  showSummary?:boolean;
}

export class Page {
  // The number of elements in the page
  size: number = 0;
  // The total number of elements
  totalElements: number = 0;
  // The total number of pages
  totalPages: number = 0;
  // The current page number
  pageNumber: number = 0;
}

export interface ConditionKeys {
  FieldKey: string;
  QueryCondition: string;
  Value: string;
  ConditionType: string;
  Conditions: string;
}
